import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
var _excluded = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import api from 'utils/api';
import { setSuccessAlert, setAlert } from 'actions/alerts';
import userEmailsKeys from './queryKeys';
export function useVerifyMyEmail() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    options = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var queryClient = useQueryClient();
  function verifyMyEmail(_x) {
    return _verifyMyEmail.apply(this, arguments);
  }
  function _verifyMyEmail() {
    _verifyMyEmail = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var token;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            token = _ref2.token;
            return _context.abrupt("return", api('post', '/api/me/email/verify', null, {
              token: token
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _verifyMyEmail.apply(this, arguments);
  }
  var _useMutation = useMutation(_objectSpread(_objectSpread({
      mutationFn: verifyMyEmail
    }, options), {}, {
      onSuccess: function onSuccess() {
        setSuccessAlert({
          title: t('alert_verify_email_success')
        });
        queryClient.invalidateQueries({
          queryKey: userEmailsKeys.userEmails
        });
      },
      onError: function onError() {
        setAlert({
          title: t('alert_verify_email_error')
        });
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded);
  return _objectSpread(_objectSpread({}, result), {}, {
    verifyMyEmail: mutateAsync
  });
}